import { AgRendererComponent } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { AgentStateSummaryCellParams, AgentStateSummaryData, EStateName } from '../agent-state-summary.model';
import { _stateColors } from 'src/app/dashboard/modules/current-agent-states/current-agent-states.models';

@Component({
    selector: 'cv-agent-state-summary-cell-renderer',
    templateUrl: './agent-state-summary-cell-renderer.component.html',
    styleUrls: ['./agent-state-summary-cell-renderer.component.scss']
})
export class AgentStateSummaryCellRendererComponent implements AgRendererComponent {

    params: AgentStateSummaryCellParams;
    value: string;
    setHigherMinWidth = false;
    maxWidth = 290; // 295 is max
    minWidth = 5;
    calculatedWidth: string;
    color = "#000000";
    hideContainer = true;

    constructor() { }

    refresh(params: AgentStateSummaryCellParams): boolean {
        this.setRows(params);
        return true;
    }

    agInit(params: AgentStateSummaryCellParams): void {
        this.setRows(params);
    }

    setRows(params: AgentStateSummaryCellParams) {
        this.params = params;
        this.value = params.data.formattedDuration;
        this.calculatedWidth = (params.data.percentage * 100).toFixed(2);
        this.setMinWidth();
        this.color = this.getStateColor(params.data);
        if (params.data.agentStateName === "Total") {
            this.hideContainer = false;
        } 
    }

    setMinWidth() {
        this.setHigherMinWidth = this.params.getLargerDurationExists();
    }

    /**
     * Returns the color for the specified state value.  The user may have specified a custom color for that state, which is returned instead of the default colors.
     *
     * @param state AgentState object to categorize. TYPE AgentState
     */
    getStateColor(data: AgentStateSummaryData) {
        if (data !== undefined) {
            switch (data.agentStateCategory) {
                case EStateName.Available:
                    return _stateColors.green;
                case EStateName.WorkingContacts:
                    return _stateColors.purple;
                case EStateName.AwaitingContacts:
                    return _stateColors.yellow;
                case EStateName.Ended:
                    return _stateColors.gray;
                case EStateName.Created:
                    return _stateColors.blue;
                case EStateName.Unavailable:
                default: // Probably a custom one.
                    return _stateColors.red;
            }
        }
        return _stateColors.red;
    }
}
